import { render } from "./BootstrapView.vue?vue&type=template&id=4e4eaaab&ts=true"
import script from "./BootstrapView.vue?vue&type=script&lang=ts"
export * from "./BootstrapView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__